import React, { useCallback } from 'react';
import ImportWithMappingDialog from '../../../components/common/ImportWithMappingDialog';
import { occupationalRiskService } from '../../../services/occupationalRiskService';
import type { ImportServiceAdapter, MappingColumnConfig } from '../../../types/import';

interface OccupationalRiskImportDialogProps {
  open: boolean;
  onClose: () => void;
  onImportComplete: () => void;
}

const COLUMNS: MappingColumnConfig[] = [
  { key: 'tipo_de_risco', label: 'Tipo de Risco', valueType: 'string' },
];

const COLUMN_LABELS: Record<string, string> = {
  tipo_de_risco: 'Tipo de Risco',
};

const occRiskImportAdapter: ImportServiceAdapter = {
  previewImport: (file) => occupationalRiskService.previewImport(file),
  executeImport: async (file, mappings) => {
    const result = await occupationalRiskService.importRisks(file, {
      mappings: mappings as Record<string, Record<string, string>> | undefined,
    });
    return {
      imported: result.imported,
      skipped: result.skipped,
      errors: result.errors,
    };
  },
  downloadTemplate: () => occupationalRiskService.downloadTemplate(),
};

const OccupationalRiskImportDialog: React.FC<OccupationalRiskImportDialogProps> = ({
  open,
  onClose,
  onImportComplete,
}) => {
  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <ImportWithMappingDialog
      open={open}
      onClose={handleClose}
      onImportComplete={onImportComplete}
      title="Importar Riscos Ocupacionais"
      description="Selecione um arquivo Excel (.xlsx) com os riscos ocupacionais para importar. Registros duplicados (mesmo fator de risco) serão ignorados."
      entityLabel="risco"
      templateFilename="template-importacao-riscos-ocupacionais.xlsx"
      adapter={occRiskImportAdapter}
      columns={COLUMNS}
      columnLabels={COLUMN_LABELS}
      getImportOptions={() => ({})}
    />
  );
};

export default OccupationalRiskImportDialog;
